import { FC, ReactElement } from 'react';
import S from './IntegrationDetailsModal.module.scss';

type Props = {
  details: ReactElement | string;
  name: ReactElement | string;
};
export const IntegrationDetailsModal: FC<Props> = ({ details, name }) => {
  if (!details) return null;
  return (
    <div className={S.integrationDetailsModal}>
      <h3>About {name} Integration</h3>

      {details}
    </div>
  );
};
